import React, { useState } from 'react';

const ContactLine = ({ label, name, email, phone }) => (
  <div className="rounded-xl bg-slate-50 p-3">
    <p className="text-[9px] font-black uppercase tracking-widest text-slate-400">{label}</p>
    <p className="mt-1 text-sm font-bold text-slate-800">{name || 'Not available'}</p>
    {email && <a className="block break-all text-xs text-indigo-600" href={`mailto:${email}`}>{email}</a>}
    {phone && <a className="mt-1 block text-xs text-indigo-600" href={`tel:${phone}`}>{phone}</a>}
  </div>
);

const CustomerServiceCaseCard = ({ item, selected, onSelect }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <article className={`rounded-2xl border bg-white shadow-sm ${selected ? 'border-indigo-400 ring-2 ring-indigo-100' : 'border-slate-100'}`}>
      <button
        type="button"
        aria-expanded={expanded}
        onClick={() => setExpanded((value) => !value)}
        className="flex w-full flex-wrap items-start justify-between gap-3 p-5 text-left"
      >
        <div>
          <p className="text-xs font-black uppercase tracking-widest text-indigo-600">
            Order #{item.order_id.slice(0, 8).toUpperCase()}
          </p>
          <h3 className="mt-2 font-black capitalize text-slate-900">
            {expanded ? '− ' : '+ '}{item.reason.replaceAll('_', ' ')}
          </h3>
        </div>
        <span className="rounded-full bg-amber-50 px-3 py-1 text-[9px] font-black uppercase text-amber-700">
          {item.dispute_status}
        </span>
        <span className="w-full text-[9px] font-black uppercase tracking-widest text-indigo-600">
          {expanded ? 'Hide details' : 'View details'}
        </span>
      </button>

      {expanded && (
        <div className="border-t border-slate-100 p-5 pt-4">
          <p className="whitespace-pre-wrap text-sm text-slate-600">
            {item.description || 'No description provided.'}
          </p>
          <div className="mt-4 grid gap-3 md:grid-cols-2">
            <ContactLine label="Customer" {...item.buyer} />
            <ContactLine label="Seller" {...item.seller} />
          </div>
          <div className="mt-4 flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 pt-4">
            <p className="text-xs font-bold text-slate-500">
              {item.order_status} · {item.delivery_method || 'fulfillment not specified'} · ${Number(item.order_total || 0).toFixed(2)}
            </p>
            <button
              type="button"
              onClick={onSelect}
              className="rounded-xl bg-indigo-600 px-4 py-2 text-[9px] font-black uppercase tracking-widest text-white"
            >
              {selected ? 'Selected' : 'Prepare admin request'}
            </button>
          </div>
        </div>
      )}
    </article>
  );
};

export default CustomerServiceCaseCard;
